import "../../index14.css";
import { jsxs as x, jsx as y } from "react/jsx-runtime";
import { a as V } from "../../core-DVmjA3_O.js";
import { _ as v } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import g from "../InlineLayout/index.js";
const m = "_button-layout_1uxvg_1", f = "_before_1uxvg_20", S = "_after_1uxvg_21", b = "_with-full-width_1uxvg_25", p = "_color-variant-text_1uxvg_29", h = "_color-variant-text-on-dark_1uxvg_33", T = "_color-variant-primary_1uxvg_37", z = "_color-variant-secondary_1uxvg_41", O = "_color-variant-success_1uxvg_45", w = "_color-variant-danger_1uxvg_49", F = "_style-variant-outline_1uxvg_53", k = "_style-variant-filled_1uxvg_58", L = "_style-variant-transparent_1uxvg_62", D = "_style-variant-translucent_1uxvg_68", N = "_style-variant-action_1uxvg_74", C = "_text-size-small_1uxvg_80", P = "_text-size-medium_1uxvg_84", A = "_text-size-large_1uxvg_88", W = "_disabled_1uxvg_92", I = "_visual-feedback_1uxvg_96", M = "_readOnly_1uxvg_118", t = {
  buttonLayout: m,
  before: f,
  after: S,
  withFullWidth: b,
  colorVariantText: p,
  colorVariantTextOnDark: h,
  colorVariantPrimary: T,
  colorVariantSecondary: z,
  colorVariantSuccess: O,
  colorVariantDanger: w,
  styleVariantOutline: F,
  styleVariantFilled: k,
  styleVariantTransparent: L,
  styleVariantTranslucent: D,
  styleVariantAction: N,
  textSizeSmall: C,
  textSizeMedium: P,
  textSizeLarge: A,
  disabled: W,
  visualFeedback: I,
  readOnly: M
}, j = {
  text: t.colorVariantText,
  primary: t.colorVariantPrimary,
  secondary: t.colorVariantSecondary,
  success: t.colorVariantSuccess,
  danger: t.colorVariantDanger,
  "text-on-dark": t.colorVariantTextOnDark
}, B = {
  outline: t.styleVariantOutline,
  filled: t.styleVariantFilled,
  transparent: t.styleVariantTransparent,
  translucent: t.styleVariantTranslucent,
  action: t.styleVariantAction
}, q = {
  sm: t.textSizeSmall,
  md: t.textSizeMedium,
  lg: t.textSizeLarge
};
function R(e) {
  const {
    colorVariant: n = "secondary",
    styleVariant: r = "translucent",
    spacingOffset: i,
    className: o,
    disabled: l,
    children: s,
    withoutPadding: c = !1,
    withFullWidth: u = !1,
    textSize: a,
    readOnly: _,
    ...d
  } = e;
  return /* @__PURE__ */ x(
    g,
    {
      withPadding: !c,
      className: v(
        t.buttonLayout,
        j[n],
        B[r],
        l && t.disabled,
        u && t.withFullWidth,
        V(a) && q[a],
        _ && t.readOnly,
        o
      ),
      spacingOffset: i,
      withAdditionalInlinePadding: !0,
      withInlineDisplay: !0,
      beforeContainerClassName: t.before,
      afterContainerClassName: t.after,
      ...d,
      children: [
        s,
        /* @__PURE__ */ y("span", { className: t.visualFeedback })
      ]
    }
  );
}
export {
  R as default
};
